export default __webpack_public_path__ + "static/media/ExcavationandTrenching.7684c3ed.pdf";